<template>
    <div class="tab-pane active">
        <div v-if="(groupsListCopy && groupsListCopy.length > 0) || add" class="table-wrapper no-print">
            <table
                v-show="!searchKeyword || filteredGroupsList.length || add"
                id="forAT_table-StaffGroups"
                class="common-table staff-table staff-groups-table"
            >
                <thead>
                    <tr class="tbl-header">
                        <th>{{ $t('staff.groupsTab.table.columns.assignable') }}</th>
                        <th>{{ $t('staff.groupsTab.table.columns.groupName') }}</th>
                        <th class="members-column">{{ $t('staff.groupsTab.table.columns.members') }}</th>
                        <th class="comments">{{ $t('staff.groupsTab.table.columns.comments') }}</th>
                        <th>{{ $t('staff.groupsTab.table.columns.actions') }}</th>
                    </tr>
                </thead>
                <tbody id="add-group-form" tabindex="1">
                    <tr v-if="add">
                        <td colspan="4">{{ $t('staff.groupsTab.newGroupLabel') }}</td>
                        <td>
                            <div class="actions">
                                <a
                                    class="btn-edit"
                                    :class="{ disabled: !unsavedChanges || !isValid }"
                                    @click.prevent="saveGroup(null)"
                                    ><i class="icon-checkmark"></i
                                ></a>
                                <a class="btn-trash" @click.prevent="cancelChanges" @dblclick.stop=""
                                    ><i class="icon-close"></i
                                ></a>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="add" class="staff-add">
                        <AddEditStaffGroupForm
                            v-model="staffGroup"
                            :staff="memberOptions"
                            :is-assigned="isAssigned"
                            :all-staff-members="allStaffMembers"
                            :all-staff-groups="allStaffGroups"
                            @updateValid="updateValid"
                        />
                    </tr>
                </tbody>
                <tbody v-for="(row, index) in filteredGroupsList" :key="index">
                    <tr @dblclick.prevent="insertEditForm(row.staff_group_id)">
                        <!--v-if="membersLength()" v-hide="{ width: membersWidth, buttonId: 'lengthCounter' + row.staff_group_id }">// TODO https://jira.ascom-ws.com/browse/MERA-599 -->
                        <td>
                            <div>
                                <input
                                    :id="'sginputOne-' + index"
                                    type="checkbox"
                                    :class="{ checked: row.assignable }"
                                />
                                <label :for="'sginputOne-' + index"></label>
                            </div>
                        </td>
                        <td :title="row.name">{{ row.name }}</td>
                        <td class="staff-group-members">
                            <span
                                v-for="(user, index2) in order(row.users)"
                                :key="index2"
                                :class="{
                                    'group-member': true,
                                    'user-inactive': row.assignable && !user.assignable,
                                }"
                                :title="user.first_name + ' (' + (user.call_id ? user.call_id : ' - ') + ')'"
                            >
                                {{ user.first_name }} <i>({{ user.call_id ? user.call_id : ' - ' }})</i>
                            </span>
                        </td>
                        <td class="comment">
                            <p
                                class="comment-text-hidden"
                                :title="$t('common.clickToExpand')"
                                @click.prevent="toggleOpenRow"
                            >
                                {{ row.comment }}
                            </p>
                        </td>
                        <td>
                            <div class="actions">
                                <a
                                    v-if="(edit && row.staff_group_id != currentGroupId) || !edit"
                                    class="btn-edit"
                                    :class="{ disabled: add || edit }"
                                    @click.prevent="insertEditForm(row.staff_group_id)"
                                >
                                    <i class="icon-edit-box"></i
                                ></a>
                                <a
                                    v-if="(edit && row.staff_group_id != currentGroupId) || !edit"
                                    class="btn-trash"
                                    :class="{ disabled: add || edit }"
                                    @click.prevent="removeGroupEntries(row.staff_group_id, row.name)"
                                >
                                    <i class="icon-trash"></i
                                ></a>
                                <a
                                    v-if="edit && row.staff_group_id == currentGroupId"
                                    class="btn-edit"
                                    :class="{ disabled: !unsavedChanges }"
                                    @click.prevent="undoChanges"
                                >
                                    <i class="icon-arrow-left"></i
                                ></a>
                                <a
                                    v-if="edit && row.staff_group_id == currentGroupId"
                                    class="btn-edit"
                                    :class="{ disabled: !unsavedChanges || !isValid }"
                                    @click.prevent="saveGroup(row.staff_group_id)"
                                >
                                    <i class="icon-checkmark"></i
                                ></a>
                                <a
                                    v-if="edit && row.staff_group_id == currentGroupId"
                                    class="btn-trash"
                                    @click.prevent="cancelEdit"
                                    @dblclick.stop=""
                                    ><i class="icon-close"></i
                                ></a>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="edit && row.staff_group_id == currentGroupId" class="staff-edit">
                        <AddEditStaffGroupForm
                            v-model="staffGroup"
                            :staff="memberOptions"
                            :is-assigned="isAssigned"
                            :all-staff-members="allStaffMembers"
                            :all-staff-groups="allStaffGroups"
                            @updateValid="updateValid"
                        />
                    </tr>
                </tbody>
            </table>
            <h3 v-if="searchKeyword && !filteredGroupsList.length">
                {{ $t('common.searchNoResult', { val: searchKeyword }) }}
            </h3>
        </div>
        <div v-else class="data-empty no-print">
            <h3 v-if="dataLoaded" v-text="$t('staff.groupsTab.noStaffGroups')"></h3>
        </div>
        <div class="print-only">
            <h4 v-if="searchKeyword && filteredGroupsList.length > 0">
                {{ $t('print.search', { val: searchKeyword }) }}
            </h4>
            <table
                v-if="groupsListCopy && groupsListCopy.length > 0"
                id="forAT_table-StaffGroups-print"
                class="table print-staff-groups"
            >
                <thead>
                    <tr class="tbl-header">
                        <th v-text="$t('staff.groupsTab.table.columns.assignable')"></th>
                        <th v-text="$t('staff.groupsTab.table.columns.groupName')"></th>
                        <th v-text="$t('staff.groupsTab.table.columns.members')"></th>
                        <th class="comments">{{ $t('staff.groupsTab.table.columns.comments') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, index) in filteredGroupsListCopy" :key="index">
                        <td><i v-if="row.assignable" class="icon-checkmark"></i></td>
                        <td>{{ row.name }}</td>
                        <td>
                            <span
                                v-for="(user, index2) in row.users"
                                :key="index2"
                                class="group-member-print"
                                v-text="user.first_name + ' (' + (user.call_id ? user.call_id : ' - ') + ')'"
                            ></span>
                        </td>
                        <td class="comment">{{ row.comment }}</td>
                    </tr>
                </tbody>
            </table>
            <h3 v-else class="data-empty" v-text="$t('staff.groupsTab.noStaffGroups')"></h3>
        </div>
    </div>
</template>

<script type="text/babel">
import AddEditStaffGroupForm from './AddEditStaffGroupForm.vue';
import staffUtils, { updateStaffMembers } from './staffUtils';
import { mapActions, mapState, mapMutations } from 'vuex';
import orderBy from 'lodash-es/orderBy';
import mappingState from '../common/mappingState';
import { resourceStaffGroup, resourceStaffMembers, resourceStaffGroupsInAA } from '../../api/resources';
import { getCancelToken } from '../../api';
import { errorHandler, unsavedHandler, ifIsNotCanceled } from '../common/helpers';
import { SUCCESS, ROUTE_NAMES, USER_TYPES, KEYS } from '../../constants';

export default {
    name: 'StaffGroups',

    components: {
        AddEditStaffGroupForm,
    },

    mixins: [staffUtils, mappingState],

    data() {
        return {
            groupsList: [],
            groupsListCopy: [],
            allStaffMembers: [],
            staffMembersInAA: [],
            staffGroup: {
                staff_group_id: null,
                name: '',
                assignable: false,
                comment: '',
                users: [],
            },
            currentGroupId: null,
            memberOptions: [],
            edit: false,
            add: false,
            isValid: false,
            emptyLabel: '',
            dataLoaded: false,
            membersWidth: null,
            cancelToken: getCancelToken(),
        };
    },

    computed: {
        ...mapState({
            unsavedChanges: 'unsavedChanges',
            showConfirm: state => state.confirm.showConfirm,
        }),

        filteredGroupsList() {
            let keyword = this.searchKeyword;
            return keyword
                ? orderBy(
                      this.groupsList.filter(
                          item =>
                              item.name.toLowerCase().indexOf(keyword) > -1 ||
                              (item.comment || '').toLowerCase().indexOf(keyword) > -1 ||
                              (item.users || []).some(
                                  member =>
                                      (member.first_name || '').toLowerCase().indexOf(keyword) > -1 ||
                                      (member.call_id || '').toLowerCase().indexOf(keyword) > -1
                              )
                      ),
                      'name'
                  )
                : orderBy(this.groupsList, 'name');
        },

        filteredGroupsListCopy() {
            let keyword = this.searchKeyword;
            return keyword
                ? orderBy(
                      this.groupsListCopy.some(
                          item =>
                              item.name.toLowerCase().indexOf(keyword) > -1 ||
                              (item.comment || '').toLowerCase().indexOf(keyword) > -1 ||
                              (item.users || []).some(
                                  member =>
                                      (member.first_name || '').toLowerCase().indexOf(keyword) > -1 ||
                                      (member.call_id || '').toLowerCase().indexOf(keyword) > -1
                              )
                      )
                          ? this.groupsListCopy.filter(
                                item =>
                                    item.name.toLowerCase().indexOf(keyword) > -1 ||
                                    (item.comment || '').toLowerCase().indexOf(keyword) > -1 ||
                                    (item.users || []).some(
                                        member =>
                                            (member.first_name || '').toLowerCase().indexOf(keyword) > -1 ||
                                            (member.call_id || '').toLowerCase().indexOf(keyword) > -1
                                    )
                            )
                          : this.groupsListCopy,
                      'name'
                  )
                : orderBy(this.groupsListCopy, 'name');
        },
    },

    created() {
        this.configButton({
            buttonName: 'addButton',
            action: () => {
                this.insertAddForm();
            },
            disabled: () => this.add || this.edit,
        });
        this.updateData(() => {
            this.cancelChanges();
            return this.updateGroupsData();
        });
        // TODO rework hiding staff members for staff groups (https://jira.ascom-ws.com/browse/MERA-599)
        // Event listener on Members column
        // window.addEventListener('resize', this.membersLength);
        this.updateGroupsData();
    },

    mounted() {
        this.addOnKeyDownHandler({
            handlerName: this.$options.name,
            handler: event => {
                if (event.which === KEYS.ESC) {
                    if (this.unsavedChanges) {
                        let confirmMessage = {
                            confirmBody: this.$t('common.confirmCancelChangesBody'),
                        };

                        return unsavedHandler(confirmMessage)
                            .then(() => {
                                if (this.add) {
                                    this.cancelChanges();
                                } else {
                                    this.cancelEdit();
                                }
                            })
                            .catch(() => {});
                    }

                    if (this.add) {
                        this.cancelChanges();
                    } else {
                        this.cancelEdit();
                    }
                }
            },
        });
    },

    beforeDestroy() {
        this.cancelToken.cancel();
        this.removeOnKeyDownHandler(this.$options.name);
    },

    methods: {
        ...mapActions({
            addOnKeyDownHandler: 'addOnKeyDownHandler',
            removeOnKeyDownHandler: 'removeOnKeyDownHandler',
        }),

        ...mapMutations({ updateData: 'SET_UPDATE_DATA' }),

        loadData() {
            return Promise.all([
                this.loadStaffMembersList(),
                this.loadStaffGroupsList(),
                this.loadStaffGroupsListInAA(this.userAreaId),
            ]);
        },

        updateGroupsData() {
            this.showLoading(true);
            this.cancelEdit();
            this.loadAssignments(this.userAreaId);

            return this.loadData()
                .then(() => this.showLoading(false))
                .catch(
                    ifIsNotCanceled({
                        callback: response => errorHandler(response.status, ROUTE_NAMES.STAFF__MEMBERS),
                    })
                );
        },

        // Dynamically update members column width
        membersLength() {
            this.$nextTick(() => {
                let members = document.getElementsByTagName('th')[2];
                if (typeof members === 'object') {
                    this.membersWidth = getComputedStyle(members).width;
                }
            });
            return true;
        },

        cancelChanges() {
            this.add = false;
            this.resetStaffGroup();
            this.setUnsavedChanges(false);
        },

        cancelEdit() {
            this.edit = false;
            this.resetStaffGroup();
            this.setUnsavedChanges(false);
        },

        insertAddForm() {
            this.add = true;
            this.edit = false;
            this.$nextTick(() => {
                document.getElementById('add-group-form').focus();
            });
        },

        insertEditForm(groupId) {
            if (!this.add && !this.edit) {
                let editedStaffGroup = this.groupsList.find(item => item.staff_group_id === groupId);
                this.staffGroup = { ...editedStaffGroup };
                this.setGroupMembers();
                this.add = false;
                this.edit = true;
                this.currentGroupId = groupId;
            }
        },

        loadStaffGroupsListInAA(areaId) {
            return resourceStaffGroupsInAA({
                id: areaId,
                cancelToken: this.cancelToken.token,
            })
                .then(response => {
                    this.groupsList = response.data ? response.data : [];
                    this.groupsListCopy = response.data ? response.data : [];
                    this.dataLoaded = true;
                    this.setSearchEnabled(this.groupsListCopy && this.groupsListCopy.length > 0);
                })
                .catch(response => {
                    this.groupsList = [];
                    this.groupsListCopy = [];
                    this.setSearchEnabled(this.groupsListCopy && this.groupsListCopy.length > 0);
                    this.dataLoaded = true;

                    return Promise.reject(response);
                });
        },

        loadStaffMembersList() {
            return resourceStaffMembers({ cancelToken: this.cancelToken.token })
                .then(response => {
                    let data = Array.isArray(response.data) ? updateStaffMembers(response.data) : [];
                    this.allStaffMembers = data;
                    this.staffMembersInAA = data.filter(
                        item =>
                            item.type !== USER_TYPES.DEVELOPER &&
                            item.type !== USER_TYPES.SUPER_USER &&
                            item.areas !== null &&
                            item.areas.filter(area => area.id === this.userAreaId && area.primary === true)
                                .length > 0
                    );
                    this.setMemberOptions();
                })
                .catch(response => {
                    this.allStaffMembers = [];

                    return Promise.reject(response);
                });
        },

        removeGroupEntries(id, staffGroupName) {
            if (!this.add && !this.edit) {
                // Form message for confirm dialog
                let confirmation = [
                    this.$t('staff.groupsTab.removeStaffGroup', {
                        name: staffGroupName,
                    }),
                ];
                if (this.isAssigned(id, false, 'groups')) {
                    confirmation.push(this.$t('staff.groupsTab.removeStaffGroupFromAssignments'));
                }
                confirmation.push(this.$t('staff.groupsTab.areYouSure'));
                return this.confirmation({
                    confirmTitle: this.$t('staff.groupsTab.removingStaffGroup'),
                    confirmBody: confirmation,
                }).then(r => {
                    if (r) {
                        this.showLoading(true);
                        return resourceStaffGroup({ method: 'delete', id })
                            .then(this.loadData)
                            .then(() => {
                                this.showLoading(false);
                                this.setKeyword('');
                            })
                            .catch(error => {
                                ifIsNotCanceled({
                                    showPopUp: !(
                                        error &&
                                        error.status === 404 &&
                                        error.config &&
                                        error.config.method === 'delete'
                                    ),
                                    callback: response => {
                                        if (Number(response.status) === 404) {
                                            return this.loadStaffGroupsList()
                                                .then(() => this.loadStaffGroupsListInAA(this.userAreaId))
                                                .then(() => {
                                                    this.showLoading(false);
                                                })
                                                .catch(() => {
                                                    this.showLoading(false);
                                                });
                                        }
                                    },
                                })(error);
                            });
                    }
                });
            }
        },
        resetStaffGroup() {
            this.staffGroup.staff_group_id = null;
            this.staffGroup.name = '';
            this.staffGroup.assignable = false;
            this.staffGroup.comment = '';
            this.staffGroup.users = [];
        },

        saveGroup(groupId) {
            if (this.unsavedChanges && this.isValid) {
                this.showLoading(true);
                let data = JSON.stringify({
                    name: this.staffGroup.name.trim(),
                    assignable: this.staffGroup.assignable,
                    comment: this.staffGroup.comment.trim(),
                    assignmentarea_id: this.userAreaId,
                    users: this.staffGroup.users.map(item => item.user_id),
                });
                return resourceStaffGroup({ method: 'post', id: groupId, data })
                    .then(() => {
                        this.add = false;
                        this.edit = false;
                        this.setUnsavedChanges(false);
                    })
                    .then(this.loadData)
                    .then(() => {
                        this.showLoading(false);
                        this.resetStaffGroup();
                        this.popup({
                            type: SUCCESS,
                            header: this.$t('common.success'),
                            text: this.$t('common.saved'),
                        });
                        this.setKeyword('');
                    })
                    .catch(
                        ifIsNotCanceled({
                            callback: response => {
                                if ([400, 404, 409].includes(response.status)) {
                                    return this.loadData()
                                        .then(() => {
                                            this.showLoading(false);
                                            this.add = false;
                                            this.edit = false;
                                            this.setUnsavedChanges(false);
                                            this.resetStaffGroup();
                                        })
                                        .catch(() => this.showLoading(false));
                                }
                                return Promise.resolve();
                            },
                        })
                    );
            }
        },

        setGroupMembers() {
            if (this.staffGroup.users) {
                this.staffGroup.users = this.staffGroup.users.map(item => ({
                    user_id: item.user_id,
                    assignable: item.assignable,
                    name: item.first_name + ' (' + (item.call_id ? item.call_id : ' - ') + ')',
                    call_id: item.call_id,
                }));
            } else {
                this.staffGroup.users = [];
            }
        },

        setMemberOptions() {
            this.memberOptions = this.staffMembersInAA.map(item => ({
                user_id: item.user_id,
                assignable: item.assignable,
                name: item.first_name + ' (' + (item.call_id ? item.call_id : ' - ') + ')',
                call_id: item.call_id,
            }));
        },

        toggleOpenRow(e) {
            // TODO remove comment-text-hidden
            e.target.classList.toggle('comment-text-hidden');
        },

        undoChanges() {
            if (this.unsavedChanges) {
                let editedStaffGroup = this.groupsList.find(
                    item => item.staff_group_id === this.currentGroupId
                );
                this.staffGroup = { ...editedStaffGroup };
                this.setGroupMembers();
                this.$nextTick(() => {
                    this.setUnsavedChanges(false);
                });
            }
        },

        order(users) {
            return orderBy(users, 'first_name');
        },

        updateValid(value) {
            this.isValid = value;
        },
    },

    // TODO rework hiding staff members for staff groups (https://jira.ascom-ws.com/browse/MERA-599)
    // beforeDestroy() {
    //     window.removeEventListener('resize', this.membersLength);
    // }
};
</script>
